(function () {
  'use strict';

  var INSTALL_KEY = '__cruxReviewMediaDedupeV1';

  if (window[INSTALL_KEY]) return;

  window[INSTALL_KEY] = true;

  function pageMode() {
    var path = window.location.pathname.replace(/\/$/, '');

    if (path.endsWith('/pages/aura-world')) return 'worn-by-you';

    if (
      path.endsWith('/pages/review')
      && new URLSearchParams(window.location.search).get('view') === 'crux-aura-review'
    ) {
      return 'customer-photos';
    }

    return '';
  }

  var imageHashCache = new Map();

  function collectMediaUrls(review) {
    var urls = [];
    var pictureUrls = review && review.picture && review.picture.urls;

    if (pictureUrls) {
      ['original', 'huge', 'mobile', 'compact', 'small'].forEach(function (size) {
        if (pictureUrls[size]) urls.push(pictureUrls[size]);
      });
    }

    if (Array.isArray(review && review.pictures_urls)) {
      review.pictures_urls.forEach(function (picture) {
        if (typeof picture === 'string') {
          urls.push(picture);
          return;
        }

        if (!picture || typeof picture !== 'object') return;

        ['original', 'huge', 'mobile', 'compact', 'small'].forEach(function (size) {
          if (picture[size]) urls.push(picture[size]);
        });
      });
    }

    if (review && review.video && Array.isArray(review.video.thumbnail_urls)) {
      urls.push.apply(urls, review.video.thumbnail_urls);
    }

    return urls;
  }

  function normalizedUrlKey(value) {
    if (!value) return '';

    try {
      var url = new URL(value, window.location.origin);
      return (url.hostname + url.pathname).toLowerCase();
    } catch (error) {
      return String(value).split('?')[0].toLowerCase();
    }
  }

  function imageHash(value) {
    var fallbackKey = normalizedUrlKey(value);

    if (!value || !window.fetch) return Promise.resolve(fallbackKey);
    if (imageHashCache.has(value)) return imageHashCache.get(value);

    var promise = (async function () {
      var url = new URL(value, window.location.origin);
      url.searchParams.set('width', '64');
      url.searchParams.set('quality', '35');

      var response = await fetch(url.toString(), { cache: 'force-cache', mode: 'cors' });
      if (!response.ok) throw new Error('Review image request failed');

      var blob = await response.blob();
      var bitmap = await createImageBitmap(blob);
      var canvas = document.createElement('canvas');
      var context = canvas.getContext('2d', { willReadFrequently: true });
      canvas.width = 9;
      canvas.height = 8;
      context.drawImage(bitmap, 0, 0, canvas.width, canvas.height);
      if (typeof bitmap.close === 'function') bitmap.close();

      var pixels = context.getImageData(0, 0, canvas.width, canvas.height).data;
      var bits = '';
      var channelTotals = [0, 0, 0];

      for (var y = 0; y < 8; y += 1) {
        for (var x = 0; x < 9; x += 1) {
          var offset = (y * 9 + x) * 4;
          channelTotals[0] += pixels[offset];
          channelTotals[1] += pixels[offset + 1];
          channelTotals[2] += pixels[offset + 2];

          if (x === 8) continue;

          var nextOffset = offset + 4;
          var currentLuma = pixels[offset] * 0.299 + pixels[offset + 1] * 0.587 + pixels[offset + 2] * 0.114;
          var nextLuma = pixels[nextOffset] * 0.299 + pixels[nextOffset + 1] * 0.587 + pixels[nextOffset + 2] * 0.114;
          bits += currentLuma > nextLuma ? '1' : '0';
        }
      }

      var differenceHash = '';

      for (var bit = 0; bit < bits.length; bit += 4) {
        differenceHash += parseInt(bits.slice(bit, bit + 4), 2).toString(16);
      }

      var colorHash = channelTotals.map(function (total) {
        return Math.round(total / 72 / 8).toString(16).padStart(2, '0');
      }).join('');

      return 'visual:' + differenceHash + ':' + colorHash;
    })().catch(function () {
      return 'image:' + fallbackKey;
    });

    imageHashCache.set(value, promise);
    return promise;
  }

  async function mediaKey(review) {
    var urls = collectMediaUrls(review);

    if (urls[0]) return imageHash(urls[0]);

    var video = review && review.video;
    var hostedVideos = review && review.media_platform_hosted_video_infos;
    var externalVideos = review && review.video_external_ids;
    var videoId = video && (video.external_id || video.media_platform_url);

    if (!videoId && Array.isArray(hostedVideos) && hostedVideos[0]) {
      videoId = hostedVideos[0].external_id || hostedVideos[0].media_platform_url;
    }

    if (!videoId && Array.isArray(externalVideos)) videoId = externalVideos[0];
    if (videoId) return 'video:' + String(videoId).toLowerCase();

    return 'review:' + String(
      (review && (review.uuid || review.id))
      || Math.random()
    );
  }

  async function filterReviews(reviews) {
    var mode = pageMode();

    if (!mode || !Array.isArray(reviews)) return reviews;

    var keys = await Promise.all(reviews.map(mediaKey));
    var seen = Object.create(null);
    var unique = reviews.filter(function (_review, index) {
      if (seen[keys[index]]) return false;
      seen[keys[index]] = true;
      return true;
    });

    if (unique.length < 8) return unique;

    return unique.filter(function (_review, index) {
      return mode === 'worn-by-you' ? index % 2 === 0 : index % 2 === 1;
    });
  }

  function wrapCarouselUtils(utils) {
    if (!utils || typeof utils.getReviews !== 'function' || utils.getReviews.__cruxDedupeWrapped) {
      return utils;
    }

    var originalGetReviews = utils.getReviews;

    function getFilteredReviews(params, settings) {
      var expandedParams = Object.assign({}, params, { max_reviews: '40' });
      return Promise.resolve(originalGetReviews.call(this, expandedParams, settings)).then(filterReviews);
    }

    getFilteredReviews.__cruxDedupeWrapped = true;
    utils.getReviews = getFilteredReviews;
    return utils;
  }

  var carouselUtils = window.jdgmCarouselUtils;

  function reviewPageUrl() {
    var root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return (root || '/').replace(/\/?$/, '/') + 'pages/review?view=crux-aura-review';
  }

  function linkWornByYouTitle() {
    if (pageMode() !== 'worn-by-you') return;

    var title = document.querySelector(
      '#MainContent [id$="__176509512515eea453"] .jdgm-title'
    );

    if (!title || title.querySelector('a')) return;

    var link = document.createElement('a');
    link.className = 'crux-worn-by-you-link';
    link.href = reviewPageUrl();
    link.textContent = title.textContent.trim();
    title.replaceChildren(link);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', linkWornByYouTitle, { once: true });
  } else {
    linkWornByYouTitle();
  }

  document.addEventListener('shopify:section:load', linkWornByYouTitle);

  if (carouselUtils) {
    wrapCarouselUtils(carouselUtils);
    return;
  }

  Object.defineProperty(window, 'jdgmCarouselUtils', {
    configurable: true,
    enumerable: true,
    get: function () {
      return carouselUtils;
    },
    set: function (value) {
      carouselUtils = wrapCarouselUtils(value);
    },
  });
})();
